import {getField, updateField} from 'vuex-map-fields';
import BatchRunHistoryGraph from '@/commonFunction/baseTableModule'

let batch_run_history_graph = new BatchRunHistoryGraph('/ws/table/batch_run_history_graph/');

const state = {
    ...batch_run_history_graph.state,
    options: {
                page: 1,
                itemsPerPage: -1,
                sortBy: ['week_start'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: false,

            },
    columns: [
        {text: 'Year/Week', value: 'week_start', sortable: true, divider: true, width: 120, brief: null,},
        {text: 'Margin Performance 1W', value: 'production_performance', sortable: false, divider: true, brief: false,},
        {text: 'Margin Performance 3W', value: 'production_performance_3w', sortable: false, divider: true, brief: false,},
        {text: 'Margin Performance 10W', value: 'production_performance_10w', sortable: false, divider: true, brief: false,},
        {text: 'Work FTE / Plan FTE', value: 'work_by_plan', sortable: false, divider: true, brief: false,},
        {text: 'Sick FTE', value: 'sick_fte', sortable: false, divider: true, brief: false,},
        {text: 'Vacation FTE', value: 'vacation_fte', sortable: false, divider: true, brief: false,},
    ],
};
const getters = {
    ...batch_run_history_graph.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {    ...batch_run_history_graph.actions,
};
const mutations = {
    ...batch_run_history_graph.mutations,
};

export default {
    modules: {
        BatchRunHistoryGraph: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}